<template>
  <b-container class="home-container container-xl vali-hollow-logo">
    <div class="text-left">
      <b-row>
        <b-col>
          <h1 class="mt-2">
            A mikro-, kis- és középvállalkozások <br />
            modern üzleti és termelési kihívásokhoz <br />
            való alkalmazkodását segítő fejlesztések <br />
            támogatása
          </h1>

          <p class="mt-5">
            A pályázati felhívás célja, hogy a valós igényekhez igazodó megoldásokat kínáljon az eltérő piaci
            pozíciókban és különféle élethelyzetekben működő vállalkozások számára, segítséget nyújtson a technológiai
            háttér megteremtésében és a digitális eszközök, online alkalmazások vagy ipar 4.0 megoldások bevezetésében.
            Cél, hogy a támogatás révén modern technológiák beszerzésére, a korszerű infrastrukturális feltételek
            megteremtésére és digitalizált üzleti és termelési folyamatok kialakítására kerüljön sor, aminek révén a
            fejlesztést megvalósító vállalkozások körében javul az erőforrás-hatékonyság és/vagy az előállított
            termékek/szolgáltatások minősége, ez pedig magasabb termelékenységi szinthez vezet.
          </p>

          <b-button
            class="mt-2"
            variant="primary"
            href="https://www.palyazat.gov.hu/megjelent-a-ginop-plusz-121-21-felhvs"
            target="_blank"
            >Tovább a pályázati felhívásra</b-button
          >

          <h5 class="mt-4">Ki nyújthat be támogatási kérelmet?</h5>

          <div class="bg-color-lightblue rounded p-5 mt-4">
            <div class="row">
              <div class="col-12 col-lg-4 mx-auto">
                <div class="row">
                  <div class="col-2 ">
                    <svg width="25" height="30" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12.5 5.35747V0.043457H0V23.9565H25V5.35747H12.5ZM5 21.2995H2.5V18.6425H5V21.2995ZM5 15.9855H2.5V13.3285H5V15.9855ZM5 10.6715H2.5V8.01447H5V10.6715ZM5 5.35747H2.5V2.70046H5V5.35747ZM10 21.2995H7.5V18.6425H10V21.2995ZM10 15.9855H7.5V13.3285H10V15.9855ZM10 10.6715H7.5V8.01447H10V10.6715ZM10 5.35747H7.5V2.70046H10V5.35747ZM22.5 21.2995H12.5V18.6425H15V15.9855H12.5V13.3285H15V10.6715H12.5V8.01447H22.5V21.2995ZM20 10.6715H17.5V13.3285H20V10.6715ZM20 15.9855H17.5V18.6425H20V15.9855Z"
                        fill="#00903C"
                      />
                    </svg>
                  </div>
                  <div class="col-10 text-green mt-1">
                    mikro-, kis-, és középvállalkozások
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ul class="mt-4">
            <li>amelyek rendelkeznek legalább 1 lezárt, teljes üzleti évvel</li>
            <li>
              amelyek éves átlagos statisztikai állományi létszáma a támogatási kérelem benyújtását megelőző lezárt,
              teljes, de 2019-nél nem korábbi üzleti évben legalább 3 fő volt
            </li>
            <li>
              amelyek Magyarország területén székhellyel rendelkező kettős könyvvitelt vezető gazdasági társaságok,
              kettős könyvvitelt vezető egyéni vállalkozók és egyéni cégek, vagy az Európai Gazdasági Térség területén
              székhellyel és Magyarországon fiókteleppel rendelkező kettős könyvvitelt vezető gazdasági társaságok
              fióktelepei
            </li>
            <li>amelyek nem tartoznak a KATA hatálya alá.</li>
          </ul>

          <h5 class="mt-4">Milyen tevékenységek támogathatóak?</h5>
          <ul class="mt-4">
            <li>
              Technológiafejlesztés, beleértve a termelési és szolgáltatási, valamint infokommunikációs technológia
            </li>
            <li>fejlesztését, a technológiai kapacitások bővítését, és az üzleti felhőszolgáltatások igénybevételét</li>
            <li>Infrastrukturális és ingatlan beruházás</li>
            <li>Tanácsadási szolgáltatások igénybevétele</li>
            <li>Képzési szolgáltatások igénybevétele</li>
            <li>Eszközbeszerzéshez kapcsolódó gyártási licenc, gyártási know-how beszerzése</li>
            <li>Megújuló energiaforrást hasznosító technológiák alkalmazása</li>
          </ul>

          <div class="row mt-4">
            <div class="col-lg-6 col-md-6 col-sm-12 p-3">
              <h5>Mennyi támogatást lehet igényelni?</h5>
              <div class="bg-color-lightblue p-5 text-green rounded bold mt-3 text-center">
                10 000 000 – 629 300 000 Ft
              </div>
              <p class="small mt-3">
                A visszatérítendő támogatás bizonyos feltételek teljesülése mellett részben vagy egészben vissza nem
                térítendővé válik. <br />
                A támogatás vissza nem térítendővé átfordításához olvassa el a pályázati útmutatót.
              </p>
              <div
                class="bg-color-lightblue p-3 text-green rounded"
                @click="openLinkNewTab('../static/TVT_Palyazoi_kezikonyv_MGFU_eredmenyessegi_meres.pdf')"
                style="cursor: pointer"
              >
                Pályázói kézikönyv az MGFÜ eredményességi méréshez kapcsolódó szolgáltatásairól
                <arrow-right-icon />
              </div>
              <div
                class="bg-color-lightblue p-3 text-green mt-2"
                @click="openLinkNewTab('../static//TVT_eredmenyessegi_meres_utmutato.pdf')"
                style="cursor: pointer"
              >
                Eredményességi mérés útmutató A GINOP Plusz 1.2.1-21 felhívás 7. számú szakmai melléklete.
                <arrow-right-icon />
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 p-3">
              <h5>Mennyi előleg igényelhető?</h5>
              <div class="bg-color-lightblue p-5 text-green rounded bold mt-3 text-center">
                100%, maximum 629 300 000 Ft
              </div>
              <p class="small mt-3">
                Önerő szükséges a projekthez, minimum 30% mértékben
                <br /><br />
                <br />
              </p>
            </div>
          </div>

          <h5 class="mt-4">Mikor lehet benyújtani a támogatási kérelmet?</h5>

          <svg style="width: 100%" viewBox="0 0 1344 27" fill="none" xmlns="http://www.w3.org/2000/svg" class="mt-4">
            <rect width="1344" height="27" rx="13.5" fill="#F2F8FA" />
            <rect x="113" width="204" height="27" rx="13.5" fill="#00903C" />
            <rect x="455" width="204" height="27" rx="13.5" fill="#00903C" />
            <rect x="797" width="204" height="27" rx="13.5" fill="#00903C" />
            <rect x="1140" width="204" height="27" rx="13.5" fill="#00903C" />
          </svg>
          <div class="row mt-3">
            <div class="col-2 offset-1">
              2021. július 2. - Kitöltő program és pályázati űrlap megnyitása
            </div>
            <div class="col-2 offset-1">
              1. benyújtási szakasz: 2021. július 12. - 2021. július 19.
            </div>
            <div class="col-2 offset-1">
              2. benyújtási szakasz: 2021. október 11. - 2021. október 18.
            </div>
            <div class="col-2 offset-1">
              3. benyújtási szakasz: 2022. január 10. - 2022. január 17.
            </div>
          </div>

          <h5 class="mt-5">
            Mi a kötelező vállalás?
          </h5>

          <p class="mt-4">
            A támogatást igénylőnek vállalnia kell, hogy termelő/szolgáltató tevékenységéhez kapcsolódóan korszerű
            vállalati technológiai megoldásokat alkalmaz. A felhívás szempontjából korszerű vállalati technológiának
            minősülő megoldásokat tartalmazó útmutatót itt találja:
          </p>

          <div
            class="bg-color-lightblue rounded p-3 text-green mt-2"
            @click="openLinkNewTab('../static/TVT_Palyazoi_kezikonyv_korszeru_vallalati_tech_megoldasok.pdf')"
            style="cursor: pointer"
          >
            Pályázói kézikönyv a korszerű vállalati technológiai megoldások alkalmazásához
            <arrow-right-icon />
          </div>

          <h5 class="mt-5">Hol valósítható meg a projekt?</h5>
          <p class="mt-4">
            Budapest kivételével Magyarország egész területén A 3. benyújtási szakaszban kis- és középvállalkozások csak
            Szabad Vállalkozási Zónákban megvalósuló fejlesztéseikhez igényelhetnek támogatást, ugyanakkor
            mikrovállalkozások területi korlátozás nélkül (de Budapest kivételével).
          </p>

          <h5 class="mt-5">Várhatóan hány projekt kap támogatást?</h5>
          <p class="mt-4">
            1000-3000 db
          </p>

          <h5 class="mt-5">Ügyfélszolgálat elérhetősége</h5>
          <p class="mt-4">
            Széchenyi Terv Plusz ügyfélszolgálat: 06/1 896-0000 (hétfőtől csütörtökig 8.30-16 óra között, pénteken 8.30-
            14 óra között)
          </p>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue'

export default {
  name: 'GinopPlusz-2.1.1-21',
  components: {
    ArrowRightIcon
  },
  methods: {
    openLinkNewTab(link) {
      const win = window.open(link, '_blank')
      win.focus()
    }
  }
}
</script>

<style scoped>
ul {
  padding-left: 40px;
}
li {
  margin-bottom: 5px;
}
.bold {
  font-weight: bold;
}
</style>
